import React from 'react';
import { 
  Phone, 
  Bot, 
  TrendingUp, 
  MessageSquare, 
  Users, 
  ShieldCheck 
} from 'lucide-react';

export default function Features() {
  const featuresList = [
    {
      icon: Phone,
      iconColor: "text-blue-600",
      bgColor: "bg-white",
      title: "Téléphonie Cloud",
      description: "Appels entrants et sortants en haute qualité.",
    },
    {
      icon: Bot,
      iconColor: "text-tertiary",
      bgColor: "bg-amber-50/40",
      title: "IA Intégrée",
      description: "L'IA Gaston assiste vos agents et automatise vos tâches.",
    },
    {
      icon: TrendingUp,
      iconColor: "text-blue-600",
      bgColor: "bg-white",
      title: "Analyses en temps réel",
      description: "Des rapports détaillés pour piloter votre performance.",
    },
    {
      icon: MessageSquare,
      iconColor: "text-tertiary",
      bgColor: "bg-white",
      title: "Support Omnicanal",
      description: "Gérez appels, WhatsApp, email, SMS et réseaux sociaux.",
    },
    {
      icon: Users,
      iconColor: "text-blue-600",
      bgColor: "bg-white",
      title: "CRM Intelligent",
      description: "Centralisez vos contacts et l'historique des interactions.",
    },
    {
      icon: ShieldCheck,
      iconColor: "text-tertiary",
      bgColor: "bg-white",
      title: "Sécurité Avancée",
      description: "Données protégées avec les plus hauts standards de sécurité.",
    },
  ];

  return (
    <section className="py-8 px-6 lg:px-12 max-w-7xl mx-auto">
      {/* Titre de section - AGRANDI */}
      <div className="text-center max-w-3xl mx-auto mb-8">
        <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 tracking-tight">
          Tout ce qu'il vous faut pour une expérience client exceptionnelle
        </h2>
      </div>

      {/* Grille sur 6 colonnes en desktop */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {featuresList.map((item, index) => {
          const Icon = item.icon;
          return (
            <div 
              key={index} 
              className={`${item.bgColor} p-5 rounded-2xl border border-slate-100/80 shadow-sm flex flex-col justify-start text-left hover:shadow-md transition-shadow duration-200`}
            >
              <div className="mb-3">
                <Icon className={item.iconColor} size={28} />
              </div>

              <h3 className="font-bold text-slate-900 text-sm mb-1.5 leading-snug">
                {item.title}
              </h3>
              
              <p className="text-slate-500 text-xs leading-relaxed">
                {item.description}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
}